// generated from 171_933 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const externalUserIdFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("external_user_id_filter"),
  comparison_key: z.enum([
    "1", // 99_408 (57.82%)
    "11", // 42_916 (24.96%)
    "10", // 17_415 (10.13%)
    "2", // 5_233 (3.04%)
    "12", // 4_026 (2.34%)
    "17", // 2_935 (1.71%)
  ]),
  display_name: z.string(),
  // undefined: 97_684 (56.82%), defined 74_249 (43.18%)
  // null: 1 (0.00%)
  raw_value: z.string().nullable().optional(),
  value: z.union([
    // null samples: 1 (0.00%)
    z.null(),
    // number samples: 1 (0.00%)
    z.literal(12007),
    // string samples: 171_931 (100.00%)
    z.string(),
  ]),
  varies_by_app_group: z.literal(false),
});
